import React, { Component } from 'react';
import JobsHeader from './JobsHeader.js';
import SpaceWiseJobs from './SpaceWiseJobs';
import ProductGroupTile, { isGroupStale } from './ProductGroupTile.js';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import Chip from '@material-ui/core/Chip';
import Loader from './../../../../commons/Loader.js';
import ErrorBox from './../../../../commons/ErrorBox';
import Tick from './../../../../assets/img/tick.png';

export default class JobsAssignment extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checkedAll: false,
			putawayJobs: null,
			arrayForSpaceMap: null,
			spaceDataToShow: null,
			allUsers: null,
			multiSelected: null,
			sortingOption: 'Sort By Pallet',
			showLoader: false,
			selectedJobs: [],
			doingAssignment: false,
			showSuccessScreen: false,
			searchedText: "",
			loadFetchUsers: false,
			inwardedTimingFilter: null,
			mheChecked: false,
			nonMheChecked: false
		};
		this.getSpaceWiseJobs = this.getSpaceWiseJobs.bind(this);
		// this.selected = this.selected.bind(this);
		this.selectedSorting = this.selectedSorting.bind(this);
		this.selectedInwardedTimingFilter = this.selectedInwardedTimingFilter.bind(this);
		this.selectedEquipmentTypeFilter = this.selectedEquipmentTypeFilter.bind(this);
		this.applyMultiSelected = this.applyMultiSelected.bind(this);
		this.setFilteredData = this.setFilteredData.bind(this);
		this.getSelectedChips = this.getSelectedChips.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.checkOperation = this.checkOperation.bind(this);
		this.setJobsUnselected = this.setJobsUnselected.bind(this);
		// this.selectedUser = null;
		this.assignJobs = this.assignJobs.bind(this);
		this.closeError = this.closeError.bind(this);
		this.reloadScreen = this.reloadScreen.bind(this);
		this.fetchJobs = this.fetchJobs.bind(this);
		this.closeSuccessScreen = this.closeSuccessScreen.bind(this);
		this.jobActionPerformed = this.jobActionPerformed.bind(this);
		this.searchedTextChange = this.searchedTextChange.bind(this);
	}

	searchedTextChange(text) {
		this.setState({ searchedText: text });
	}

	handleAllCheckChange() {

	}

	// selected(user) {
	// 	this.selectedUser = user;
	// }

	closeSuccessScreen() {
		this.setState({ showSuccessScreen: false });
	}

	selectedSorting(sortingOption) {
		var jobs = this.state.putawayJobs;
		var spaces = this.state.arrayForSpaceMap;
		for (let i in jobs) {
			jobs[i].checked = false;
		}
		for (let i in spaces) {
			spaces[i].checkedAll = false;
		}
		this.setState({ sortingOption: sortingOption, putawayJobs: jobs, selectedJobs: [], searchedText: "" });
	}

	selectedInwardedTimingFilter(option) {
		this.setState({ inwardedTimingFilter: option });
	}

	selectedEquipmentTypeFilter(mheChecked, nonMheChecked) {
		this.setState({ mheChecked: mheChecked, nonMheChecked: nonMheChecked });
	}

	//<!--------------------------------- MHE = job.toSpace.needsEquipment true (destination space needs equipment to put away into), Non-MHE = false; neither/both checked = no restriction ---------------------------------!>
	matchesEquipmentTypeFilter(job) {
		var mheChecked = this.state.mheChecked;
		var nonMheChecked = this.state.nonMheChecked;
		if (!mheChecked && !nonMheChecked) {
			return true;
		}
		var needsEquipment = job.toSpace && job.toSpace.needsEquipment;
		if (mheChecked && needsEquipment === true) {
			return true;
		}
		if (nonMheChecked && needsEquipment === false) {
			return true;
		}
		return false;
	}

	closeError() {
		this.setState({ error: null });
	}

	seggregateForEachSpace() {
		var jobs = this.state.putawayJobs;
		var result = {};
		//Making map for spaceName to jobs array {space:[jobs]}
		for (var i of jobs) {
			if (!result[i.fromSpace.spaceDisplayName]) {
				result[i.fromSpace.spaceDisplayName] = [];
			}
			result[i.fromSpace.spaceDisplayName].push(i);
		}
		var arrayForSpaceMap = Object.keys(result).map((key) => { return { spaceName: String(key), jobs: result[key] } });
		jobs.sort(function (a, b) { return (a.productDetails.title > b.productDetails.title) ? 1 : ((b.productDetails.title > a.productDetails.title) ? -1 : 0); });
		arrayForSpaceMap.sort(function (a, b) { return (a.spaceName > b.spaceName) ? 1 : ((b.spaceName > a.spaceName) ? -1 : 0); });
		this.setState({
			arrayForSpaceMap: arrayForSpaceMap,
			spaceDataToShow: arrayForSpaceMap
		});
	}

	fetchJobs() {
		this.setState({ showLoader: true });
		JobsOperationsApiHandler.getPendingJobsForProcessType(this.props.processType)
			.then(function (resp) {
				this.setState({ putawayJobs: resp });
				this.seggregateForEachSpace();
			}.bind(this)).catch(function (error) {
				this.setState({ error: error.error.error });
			}.bind(this)).finally(function () {
				this.setState({ showLoader: false });
			}.bind(this))
	}

	fetchUsers(showAllUsers) {
		//showAllUsers === true : get all users ? get users for that facility

		this.setState({ loadFetchUsers: true });
		JobsOperationsApiHandler.getFcUsersForProcessType(this.props.userType, showAllUsers)
			.then(function (resp) {
				this.setState({ allUsers: resp });
			}.bind(this)).catch(function (error) {

			}).finally(() => {
				this.setState({ loadFetchUsers: false });
			})

	}

	componentDidMount() {
		this.fetchJobs();
		this.fetchUsers(false);
	}

	setJobsUnselected() {
		var spaces = this.state.arrayForSpaceMap;
		for (let i in spaces) {
			spaces[i].checkedAll = false;
			for (let j in spaces[i].jobs) {
				spaces[i].jobs[j].checked = false;
			}
		}
		this.setState({ arrayForSpaceMap: spaces });
	}

	setFilteredData(selected) {
		this.setJobsUnselected();
		this.setState({
			multiSelected: selected,
			spaceDataToShow: selected,
			selectedJobs: []
		})
	}

	applyMultiSelected(selected) {
		this.setState({
			spaceDataToShow: []
		});
		this.setFilteredData(selected);
	}

	reloadScreen() {
		this.setState({
			checkedAll: false,
			putawayJobs: null,
			arrayForSpaceMap: null,
			spaceDataToShow: null,
			allUsers: null,
			multiSelected: null,
			sortingOption: 'Sort By Pallet',
			selectedJobs: [],
			doingAssignment: false
		});
		this.componentDidMount();
	}

	//<!--------------------------------- Marking something checked or unchecked ---------------------------------!> 	
	// users is a single user, or an array of users when allowMultipleUsers is set (jobs are split across them)
	assignJobs(users) {
		if (this.state.doingAssignment) {
			return;
		}
		this.setState({ doingAssignment: true });
		var imrs = this.state.selectedJobs.map((job) => {
			return ({
				inventoryMovementRequestIds: job.inventoryMovementRequestIds,
				qtyToTransfer: job.qtyToTransfer
			})
		});
		var req = {
			requests: imrs,
			processPhase: this.props.processPhase,
			processType: this.props.processType
		};
		var assignmentCall;
		if (this.props.allowMultipleUsers) {
			req.userIdsToAssign = users.map((user) => user.naturalId);
			assignmentCall = JobsOperationsApiHandler.generateAndAssignJobsToUsers(req);
		} else {
			req.userIdToAssign = users.naturalId;
			assignmentCall = JobsOperationsApiHandler.generateAssignmentJobs(req);
		}
		assignmentCall
			.then(response => {
				this.setState({ showSuccessScreen: true });
				this.reloadScreen();
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ doingAssignment: false });
			})
	}

	//<!--------------------------------- Marking something checked or unchecked ---------------------------------!> 	
	checkOperation(selected, spaceName, checked) {
		var select = this.state.selectedJobs;
		var spaces = this.state.spaceDataToShow;
		var selectedImprove = [];
		for (let i in select) {
			if (select[i].fromSpace.spaceDisplayName !== spaceName) {
				selectedImprove.push(select[i]);
			}
		}
		for (let i in spaces) {
			if (spaces[i].spaceName === spaceName) {
				spaces[i].checkedAll = checked;
			}
		}
		var final = selectedImprove.concat(selected);
		console.log(spaceName);
		console.log(final);
		this.setState({ selectedJobs: final, spaceDataToShow: spaces });
	}

	//<!--------------------------------- Deleting a Chip AKA Space ---------------------------------!> 	
	handleDelete(space) {
		this.setState({ spaceDataToShow: [] });
		var multiSelected = this.state.multiSelected;
		for (var i in multiSelected) {
			if (multiSelected[i].spaceName === space.spaceName) {
				break;
			}
		}
		multiSelected.splice(i, 1);
		if (multiSelected.length === 0) {
			this.setState({
				multiSelected: multiSelected,
				spaceDataToShow: this.state.arrayForSpaceMap
			})
		} else {
			this.setState({
				multiSelected: multiSelected,
				spaceDataToShow: multiSelected
			})
		}
	}

	jobActionPerformed(job) {
		var selectedJobs = this.state.selectedJobs;
		if (job.checked) {
			selectedJobs.push(job);
		} else {
			for (let i in selectedJobs) {
				if (selectedJobs[i].inventoryMovementRequestIds === job.inventoryMovementRequestIds) {
					selectedJobs.splice(i, 1);
					break;
				}
			}
		}
		this.setState({ selectedJobs: selectedJobs });
		//this.props.checkOperation(selectedJobs, this.props.space.spaceName, false);
	}

	//<!--------------------------------- Gets Jobs space wise ---------------------------------!> 	
	getSpaceWiseJobs(spaces) {
		var spaceWisejobs = spaces.map((space, index) => {
			if (space.checkedAll === undefined) {
				space.checkedAll = false;
			}
			return (
				<div key={index}>
					<SpaceWiseJobs space={space} checkOperation={this.checkOperation} />
				</div>
			);
		})
		return spaceWisejobs;
	}

	//<!--------------------------------- Grouping jobs of the same product (JPIN) into one tile, filtered by search text + Inwarded Timing filter ---------------------------------!>
	getVisibleProductGroups(jobs) {
		var searchText = this.state.searchedText.toLowerCase();
		var groupsByKey = {};
		var orderedKeys = [];
		for (var job of jobs) {
			if (job.checked === undefined) {
				job.checked = false;
			}
			if (!this.matchesEquipmentTypeFilter(job)) {
				continue;
			}
			// productDetails.entityId carries the JPIN (see ProductDetails.java in jobsdk); title is a fallback if it's ever missing.
			var key = job.productDetails.entityId || job.productDetails.title;
			if (!groupsByKey[key]) {
				groupsByKey[key] = {
					title: job.productDetails.title,
					imageUrl: job.productDetails.imageUrlList[0],
					jobs: []
				};
				orderedKeys.push(key);
			}
			groupsByKey[key].jobs.push(job);
		}
		return orderedKeys.map((key) => groupsByKey[key]).filter((group) => {
			var title = group.title.toLowerCase();
			var matchesSearch = (searchText && title.indexOf(searchText) !== -1) || !searchText;
			var matchesInwardedTimingFilter = true;
			if (this.state.inwardedTimingFilter === 'More than 3 days') {
				matchesInwardedTimingFilter = isGroupStale(group.jobs);
			} else if (this.state.inwardedTimingFilter === 'Less than 3 days') {
				matchesInwardedTimingFilter = !isGroupStale(group.jobs);
			}
			return matchesSearch && matchesInwardedTimingFilter;
		});
	}

	getGroupedProductJobs(jobs) {
		return this.getVisibleProductGroups(jobs).map((group, index) => (
			<div key={index}>
				<ProductGroupTile group={group} jobActionPerformed={this.jobActionPerformed} />
			</div>
		));
	}

	//<!--------------------------------- Selected/Total counts shown in the header, dynamic per current view + filters ---------------------------------!>
	getSelectedAndTotalCounts() {
		var selectedCount = this.state.selectedJobs.length;
		var totalCount = 0;
		if (this.state.sortingOption === 'Sort By Pallet') {
			var spaces = this.state.spaceDataToShow || [];
			totalCount = spaces.reduce((sum, space) => sum + (space.jobs ? space.jobs.length : 0), 0);
		} else if (this.state.putawayJobs) {
			var visibleGroups = this.getVisibleProductGroups(this.state.putawayJobs);
			var visibleJobs = visibleGroups.reduce((allJobs, group) => allJobs.concat(group.jobs), []);
			totalCount = visibleJobs.length;
			selectedCount = visibleJobs.filter((job) => job.checked).length;
		}
		return { selectedCount: selectedCount, totalCount: totalCount };
	}

	//<!--------------------------------- Showing Selected Chips AKA Spaces ---------------------------------!>
	getSelectedChips() {
		var chips;
		if (this.state.multiSelected) {
			chips = this.state.multiSelected.map((space, index) => {
				return <Chip key={index} label={space.spaceName} onDelete={() => this.handleDelete(space)} color="primary" variant="outlined" classes={{ root: 'chipRoot', colorPrimary: 'chipColor', deleteIcon: 'chipColor' }} />
			})
		}
		return chips;
	}

	changeUsers = (showAllUsers) => {
		this.fetchUsers(showAllUsers);
	}

	render() {
		var counts = this.getSelectedAndTotalCounts();

		return (
			<div>
				<div style={{ position: 'sticky', top: 0, zIndex: 2 }}>
					<JobsHeader operationName={this.props.operationName} applyMultiSelected={this.applyMultiSelected} allSpaces={this.state.arrayForSpaceMap} allUsers={this.state.allUsers} loadFetchUsers={this.state.loadFetchUsers} changeUsers={this.changeUsers} selectedJobs={this.state.selectedJobs} selectedSorting={this.selectedSorting} selectedInwardedTimingFilter={this.selectedInwardedTimingFilter} selectedEquipmentTypeFilter={this.selectedEquipmentTypeFilter} assignJobs={this.assignJobs} allowMultipleUsers={this.props.allowMultipleUsers} doingAssignment={this.state.doingAssignment} successScreen={this.state.showSuccessScreen} searchText={this.state.searchedText} searchedTextChange={this.searchedTextChange} />
					{(this.state.sortingOption === 'Sort By Product') ?
						<div style={{ padding: '10px 0 0 0', fontSize: '16px', marginLeft: '10px', backgroundColor: '#f1f1f1' }}>
							<span style={{ opacity: '0.5' }}>Selected/Total :</span> {counts.selectedCount}/{counts.totalCount}<b>Jobs</b>
						</div>
						: null
					}
				</div>
				{(this.state.spaceDataToShow) ?
					<div className="putaway-wrapper">
						<div className="selected-chips">
							{this.getSelectedChips()}
						</div>
						{(this.state.sortingOption === 'Sort By Pallet') ?
							<div>
								{this.getSpaceWiseJobs(this.state.spaceDataToShow)}
							</div>
							:
							<div>
								{this.getGroupedProductJobs(this.state.putawayJobs)}
							</div>
						}
					</div> : null
				}
				{(this.state.putawayJobs && this.state.putawayJobs.length === 0) ?
					<div className="no-jobs-to-assign"> Yaay !!!!!!  No Jobs to assign </div> : null
				}
				{(this.state.showLoader) ?
					<Loader /> : null
				}
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
				{(this.state.showSuccessScreen) ?
					<div className="randomErrorBox">
						<div className="errorContianer" style={{ width: '300px', textAlign: 'center', color: '#58a159', fontWeight: 'bold' }}>
							<div><img src={Tick} alt="success-img" style={{ width: '65px', height: '65px' }} /></div>
							<div className="top-twenty">Job Assignment Done Successfully</div>
							<div className="top-twenty"><button className="btn btn-jt-green" onClick={this.closeSuccessScreen}>Okay</button></div>
						</div>
					</div> : null
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JobsAssignment.js